'use client';

import { Container } from '@/layers/presentation/components/common/Container';
import PageHero from '@/layers/presentation/components/common/PageHero';
import LandingLayout from '@/layers/presentation/layouts/LandingLayout';
import Link from 'next/link';
import { useEffect } from 'react';

interface ErrorPageProps {
  error: Error;
  reset: () => void;
}

export default function Error({ error, reset }: ErrorPageProps) {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Error', href: '#' },
  ];

  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Page Error:', error);
  }, [error]);

  return (
    <LandingLayout>
      <>
        <PageHero
          title="Something Went Wrong"
          breadcrumbs={breadcrumbs}
          backgroundImage="/images/hero-gradient-sponsors.jpg"
        />
        <Container>
          <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
            <h2 className="!pb-0 mb-4 text-xl sm:text-2xl md:text-3xl leading-normal">
              We encountered an unexpected error
            </h2>
            <p className="text-default-700 mb-8 max-w-2xl">
              We apologize for the inconvenience. Please try again, and if the problem persists,
              contact our support team.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <button type="button" className="rh-btn-black-lg" onClick={reset}>
                Try Again
              </button>
              <Link href="/" className="rh-btn-outline">
                Return to Home
              </Link>
            </div>
          </div>
        </Container>
      </>
    </LandingLayout>
  );
}
